import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';

import PrimaryButton from '../../../Custom-UI/Button.jsx';
import ResourcesList from '../../../Resources/ResourceListWrapper/components/ResourcesList.jsx';
import { RESOURCE_ROUTE_BY_TYPE } from '../../constants.js';

// Panel ancho, porque adentro va la grilla de cards del catálogo: con menos de
// ~1000px los cards en `small` dejan de entrar de a cuatro y se pierde el
// sentido de haber sacado el catálogo del formulario.
const panelStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  width: '92vw',
  maxWidth: 1100,
  maxHeight: '90vh',
  bgcolor: '#ffffff',
  borderRadius: 2,
  boxShadow: 24,
  outline: 'none',
};

/**
 * Modal donde se explora el catálogo y se eligen los recursos de UNA unidad.
 *
 * Saca el catálogo del plano del formulario: la página queda para componer la
 * ruta (ver y quitar lo elegido) y acá se navega con los cards en `size='small'`.
 * Reutiliza ResourcesList tal cual, en modo 'select'.
 *
 * La selección se aplica al instante sobre el estado del formulario, así que no
 * hay borrador que confirmar ni nada que cancelar: "Listo" solo cierra.
 *
 * Props:
 * - unitName: nombre de la unidad, en la cabecera, para que no haya duda de a
 *   qué unidad caen las selecciones.
 * - activeType: tipo de recurso que se está explorando.
 * - pathSegments / onDrillDown / onBack: rastro de carpetas, controlado por el
 *   formulario para que reabrir el modal caiga donde quedaste.
 * - selectedKeys / onSelect: selección del nivel actual y su toggle.
 * - countByType: conteo por tipo de la unidad, para el pie.
 */
function ResourceSelectionModal({
  open,
  onClose,
  unitName,
  activeType,
  pathSegments = [],
  onDrillDown,
  onBack,
  selectedKeys = [],
  onSelect,
  countByType = {},
}) {
  const total = Object.values(countByType).reduce((acc, count) => acc + count, 0);

  return (
    <Modal open={open} onClose={onClose} aria-labelledby='resource-selection-title'>
      <Box sx={panelStyle}>
        <div className='flex items-start justify-between gap-4 border-b border-border px-6 py-4'>
          <div className='flex flex-col text-left'>
            <h2 id='resource-selection-title' className='text-lg font-bold text-primary'>
              Agregar recursos
            </h2>
            <p className='mt-0.5 text-sm text-muted-foreground'>Unidad: {unitName}</p>
          </div>
          <IconButton onClick={onClose} size='small' aria-label='Cerrar'>
            <CloseIcon />
          </IconButton>
        </div>

        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 3, py: 3 }}>
          <ResourcesList
            size='small'
            resourceType={RESOURCE_ROUTE_BY_TYPE[activeType]}
            pathSegments={pathSegments}
            showBackButton={pathSegments.length > 0}
            onDrillDown={onDrillDown}
            onBack={onBack}
            mode='select'
            selectedKeys={selectedKeys}
            onSelect={onSelect}
          />
        </Box>

        <div className='flex items-center justify-between gap-4 border-t border-border px-6 py-4'>
          <span className='text-sm text-muted-foreground'>
            {total} {total === 1 ? 'recurso seleccionado' : 'recursos seleccionados'} en esta unidad
          </span>
          <PrimaryButton variant='contained' onClick={onClose}>
            Listo
          </PrimaryButton>
        </div>
      </Box>
    </Modal>
  );
}

export default ResourceSelectionModal;
